// Shared by the new and edit flyer pages, which render the same design and must
// keep rendering it the same way. Both values were duplicated per page, so
// tuning one and forgetting the other made create and edit export the same
// flyer at different sizes.

export const PAPER_SIZES = {
  letter: { name: "Letter", width: 22, height: 28, description: "22 x 28 cm" },
  a4: { name: "A4", width: 21, height: 29.7, description: "21 x 29.7 cm" },
  a5: { name: "A5", width: 15, height: 21, description: "15 x 21 cm" },
  a6: { name: "A6", width: 10.5, height: 14.8, description: "10.5 x 14.8 cm" },
};

// Base font size as a fraction of the flyer WIDTH. The whole design is width-
// relative — QR/logo are % of width, text is em off this base — so the layout
// is identical at any size. The on-screen preview uses this via `cqw` (% of the
// flyer's own width) and the exported PDF via `pxWidth * FONT_SCALE`, so the two
// always match, and paper-size changes scale text proportionally instead of
// leaving it a fixed px size. Bump this to make all flyer text bigger.
export const FONT_SCALE = 0.031;
